module.exports = __webpack_public_path__ + "img/effects-7.66abcdf7.png";